<div class="surface-card p-4 border-round border-1 surface-border">
  <h3 class="text-lg font-semibold mb-3">
    Couverture des dépassements de tolérance
  </h3>
  <div *ngIf="loading" class="text-center text-color-secondary">
    Chargement...
  </div>
  <canvas
    *ngIf="!loading && chartData.labels!.length > 0"
    baseChart
    [data]="chartData"
    [options]="chartOptions"
    [type]="'bar'"
  ></canvas>
  <div
    *ngIf="!loading && chartData.labels!.length === 0"
    class="text-center text-color-secondary"
  >
    Aucune donnée disponible
  </div>
</div>
